// ─────────────────────────────────────────────────────────────────────────────
// ⚠️ KEEP IN LOCKSTEP WITH backend/constants/staffRoles.js ROLE_LABELS.
// backend/test/staffRoleAccessParity.test.js fails if the two disagree.
//
// 🔑 "Real Estate Desk" IS THE LABEL FOR contract_desk, which is the value
// stored in users.role. The rename was a label change, not a destructive column
// rename, so anything shown to a person must come through here rather than
// printing the raw value.
// ─────────────────────────────────────────────────────────────────────────────
export const ROLE_LABELS = {
  admin: 'Admin',
  account_manager: 'Account Manager',
  contract_desk: 'Real Estate Desk',
  loan_officer: 'Loan Officer',
  client_success: 'Client Success',
  partner_success: 'Partner Success',
  engineering: 'Engineering',
};
